export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "click_region_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez sur une région pour voir le détail par magasins."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])},
        "no_data_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à exporter pour les filtres sélectionnés."])}
      },
      "en": {
        "click_region_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click on a region to see the breakdown by stores."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
        "no_data_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to export for the selected filters."])}
      }
    }
  })
}
